import { JsonProperty, JsonObject } from 'json2typescript';

import {Required, EmptyControl, NestedArray} from '@hvlng/framework-bff/core';
import {ObjectCardDetailModel} from "./object-card-detail-model";

@JsonObject('KovanHrObjectCardDetailFieldModel')
export class ObjectCardDetailFieldModel  {

    @NestedArray(ObjectCardDetailModel)
    @JsonProperty('fields', [ObjectCardDetailModel], true)
    fields: Array<ObjectCardDetailModel> = new Array<ObjectCardDetailModel>();

}
